module.exports = __webpack_public_path__ + "img/Bahnhof_Oravita_3kl.18409642.jpg";